<template>
    <span class="workflow-handle-biz-root">
        <template v-if="labelText">
            <el-tag v-if="clickable" type="info" size="small"
                class="workflow-handle-biz-tag workflow-handle-biz-tag--clickable" @click.native="onTagClick">
                <span class="tag-text active">{{ labelText }}</span>
            </el-tag>
            <el-tag v-else type="info" size="small" class="workflow-handle-biz-tag workflow-handle-biz-tag--readonly">
                <span class="tag-text">{{ labelText }}</span>
            </el-tag>
        </template>
        <span v-else class="readonly-empty">-</span>

        <el-dialog :visible.sync="noticeDialogVisible" title="通知内容" width="560px" append-to-body
            :close-on-click-modal="false" @closed="onNoticeDialogClosed">
            <div v-loading="noticeLoading" class="notice-detail-body">
                <template v-if="noticeRecord">
                    <div class="notice-row">
                        <span class="notice-label">标题</span>
                        <div class="notice-value">{{ noticeRecord.title || "—" }}</div>
                    </div>
                    <div v-if="noticeRecord.subTitle && noticeRecord.subTitle !== noticeRecord.title"
                        class="notice-row">
                        <span class="notice-label">副标题</span>
                        <div class="notice-value">{{ noticeRecord.subTitle }}</div>
                    </div>
                    <div class="notice-row">
                        <span class="notice-label">内容</span>
                        <div class="notice-value notice-value--html" v-html="noticeRecord.content || '—'"></div>
                    </div>
                    <div v-if="noticeImageUrls.length" class="notice-row">
                        <span class="notice-label">图片</span>
                        <div class="notice-images">
                            <el-image v-for="(url, idx) in noticeImageUrls" :key="idx" :src="url" fit="cover"
                                class="notice-img" :preview-src-list="noticeImageUrls" />
                        </div>
                    </div>
                </template>
            </div>
            <span slot="footer">
                <el-button size="small" type="primary" @click="noticeDialogVisible = false">关 闭</el-button>
            </span>
        </el-dialog>
    </span>
</template>

<script>
import { getNoticeSendingRecordRecord } from "@/api/notice";
import { getPunishBill } from "@/api/driver_punish";
import { SHOW_PUNISH_DIAG } from "@/core/const/global-event";

const CLICK_TYPES = ["NOTICE", "PUNISHMENT"];

export default {
    name: "WorkflowHandleBizTag",
    props: {
        handleType: {
            type: [String, Number],
            default: null
        },
        handleBizId: {
            type: [String, Number],
            default: null
        }
    },
    data() {
        return {
            noticeDialogVisible: false,
            noticeLoading: false,
            noticeRecord: null,
            noticeImageUrls: []
        };
    },
    computed: {



        typeCode() {
            const t = this.handleType;
            if (t === undefined || t === null || t === "") return "";
            return String(t).trim();
        },
        bizIdStr() {
            const b = this.handleBizId;
            if (b === undefined || b === null || b === "") return "";
            return String(b).trim();
        },
        labelText() {
            if (!this.typeCode) return "";

            let label = "";
            if (this.typeCode === "NOTICE") {
                label = "通知";
            } else if (this.typeCode === "PUNISHMENT") {
                label = "罚单";
            }
            if (this.bizIdStr) label = `${label}-${this.bizIdStr}`;
            return label;
        },
        clickable() {
            return (
                this.bizIdStr &&
                CLICK_TYPES.indexOf(this.typeCode) >= 0
            );
        }
    },
    methods: {
        onTagClick() {
            if (!this.clickable) return;
            if (this.typeCode === "NOTICE") {
                this.openNoticeDetail();
            } else if (this.typeCode === "PUNISHMENT") {
                this.openPunishDetail();
            }
        },
        openNoticeDetail() {
            const id = parseInt(this.bizIdStr, 10);
            if (!Number.isFinite(id)) {
                this.$message.warning("通知 ID 无效");
                return;
            }
            this.noticeDialogVisible = true;
            this.noticeLoading = true;
            this.noticeRecord = null;
            this.noticeImageUrls = [];
            getNoticeSendingRecordRecord(id)
                .then((res) => {
                    this.noticeRecord = res.data || null;
                    this.noticeImageUrls = this.extractNoticeImageUrls(this.noticeRecord);
                })
                .finally(() => {
                    this.noticeLoading = false;
                });
        },
        extractNoticeImageUrls(record) {
            if (!record || !Array.isArray(record.fields)) return [];
            const urls = [];
            record.fields.forEach((f) => {
                if (f && f.type === "img" && f.value) {
                    urls.push(f.value);
                }
            });
            return urls;
        },
        onNoticeDialogClosed() {
            this.noticeRecord = null;
            this.noticeImageUrls = [];
        },
        openPunishDetail() {
            const id = parseInt(this.bizIdStr, 10);
            if (!Number.isFinite(id)) {
                this.$message.warning("罚单 ID 无效");
                return;
            }
            getPunishBill(id).then((res) => {
                const bill = res.data;
                if (!bill) {
                    this.$message.warning("未找到罚单");
                    return;
                }
                this.$bus.$emit(SHOW_PUNISH_DIAG, { punishBill: bill, viewMode: true });
            });
        }
    }
};
</script>

<style lang="less" scoped>
.workflow-handle-biz-root {
    display: inline-block;
    max-width: 100%;
}

.workflow-handle-biz-tag {
    max-width: 220px;

    &.workflow-handle-biz-tag--readonly {
        background-color: #f4f4f5;
        border-color: #e9e9eb;
        color: #909399;
    }

    &.workflow-handle-biz-tag--clickable {
        cursor: pointer;
    }
}

.tag-text {
    display: inline-block;
    max-width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    vertical-align: middle;

    &.active {
        color: #409eff;
        text-decoration: underline;
    }
}

.readonly-empty {
    color: #909399;
}

.notice-detail-body {
    min-height: 80px;
}

.notice-row {
    margin-bottom: 12px;

    &:last-child {
        margin-bottom: 0;
    }
}

.notice-label {
    display: block;
    font-size: 12px;
    color: #909399;
    margin-bottom: 4px;
}

.notice-value {
    font-size: 13px;
    color: #303133;
    word-break: break-word;

    &--html {
        line-height: 1.5;
    }
}

.notice-images {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
}

.notice-img {
    width: 96px;
    height: 96px;
    border-radius: 4px;
}
</style>
